<template>
	<Content :style="{padding: '0 0 27px 27px'}">
		<div class="stores_title">
			<Breadcrumb>
				<BreadcrumbItem>用户管理</BreadcrumbItem>
				<BreadcrumbItem>用户角色管理</BreadcrumbItem>
			</Breadcrumb>
			<p>添加角色</p>
		</div>
		<div class="stores_container mt20">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80" class="form">
        <FormItem label="角色名称：" prop="roleName">
          <Input v-model="formValidate.roleName" placeholder="请输入角色" style="width: 400px"></Input>
        </FormItem>

        <FormItem label="状态：" prop="status">
          <RadioGroup v-model="formValidate.status">
            <Radio label="male">启用</Radio>
            <Radio label="female">禁用</Radio>
          </RadioGroup>
          <p class="statusDes">如果禁用，则当前角色的操作员全部会禁止使用</p>
        </FormItem>

        <FormItem label="可用权限：" prop="roleModuleRule">
          <div class="roleRule">
            <div class="title">
              <p class="checkAll fl">
                <Checkbox v-model="roleModuleCheckAll">&nbsp;退货模块</Checkbox>
              </p>
              <div class="expand fr">
                <div class="triangle fl">
                  <span></span>
                </div>
                <p class="fl">&nbsp;展开</p>
              </div>
            </div>
            <div class="content">
              <ul>
                <li class="fl" style="width: 10%;">
                  <Checkbox
                    :indeterminate="indeterminate"
                    :value="checkAll"
                    @click.prevent.native="handleCheckAll">
                    销售单退货：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </Checkbox>
                </li>
                <li class="fl" style="width: 90%;">
                  <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
                    <Checkbox label="香蕉"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="苹果"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                  </CheckboxGroup>
                </li>
              </ul>

              <ul>
                <li class="fl" style="width: 10%;">
                  <Checkbox
                    :indeterminate="indeterminate"
                    :value="checkAll"
                    @click.prevent.native="handleCheckAll">
                    销售单退货：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </Checkbox>
                </li>
                <li class="fl" style="width: 90%;">
                  <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
                    <Checkbox label="香蕉"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="苹果"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Checkbox label="西瓜"></Checkbox>&nbsp;&nbsp;&nbsp;&nbsp;
                  </CheckboxGroup>
                </li>
              </ul>

            </div>
          </div>
        </FormItem>



        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
          <Button type="default" @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>



		</div>
	</Content>
</template>

<script>
	export default {
		name: 'addUserRole',
		data() {
			return {
        formValidate: {
          roleName: "",
          status: "",


        },
        ruleValidate: [],
        roleModuleCheckAll: false,

			}
		},
		created(){

		},
		methods: {

		},
	}
</script>
<style lang="less" scoped>
  div.stores_container {
    .form {
      p.statusDes {
        font-family: "Microsoft YaHei";
        font-size: 14px;
        color: rgba(0, 0, 0, 0.647058823529412);
        line-height: 22px;
      }
      div.roleRule {
        width: 100%;
        border: solid 1px rgba(217, 217, 217, 1);
        div.title {
          background: rgba(244, 244, 244, 1);
          width: 100%;
          height: 38px;
          line-height: 38px;
          padding: 0px 15px;
          p.checkAll {
            .ivu-checkbox-wrapper {
              font-family: 'Microsoft YaHei';
              font-weight: 400;
              font-style: normal;
              font-size: 14px;
              color: #666666;
              text-align: left;
            }
          }
          div.expand {
            font-family: "Microsoft YaHei";
            font-weight: 400;
            font-style: normal;
            font-size: 14px;
            line-height: 38px;
            div.triangle {
              display: inline-block;
              width:0;
              height:0;
              border-width: 8px 8px 0;
              border-style:solid;
              border-color:#999999 transparent transparent;/*灰 透明 透明 */
              margin-top: 15px;
              position:relative;
            }
          }
        }
        div.content {
          ul {
            padding: 15px;
            width: 100%;
            overflow: hidden;
            /*float: left;*/
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/user/addUserRole.vue